import React from 'react';

import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import { formatSeller } from 'components/Seller';

import { PhoneNumberDDDOutput } from 'utils/PhoneNumber';
import Document from 'utils/Document';

import emailImg from 'img/email-icon.svg';
import refreshBtn from 'img/icon-refresh.svg';

import { IAddress } from 'models/Address';

import Files from 'pages/Customer/Files';

import { DataCustomerProps } from './interface';
import { Visibility } from 'components/Visibility';

export const DataCustomer: React.FC<DataCustomerProps> = (props) => {
  const { customer, refreshCustomer } = props;

  function parseEmail(emailString?: string) {
    if (!emailString) return '-';
    return emailString.split(/[\;,\s]/g).join(`\n`);
  }

  function parseAddress(address?: IAddress) {
    if (!address) return '';

    var street = address?.street ? `${address?.street}${' - '}` : '';
    const number = address?.number ? `${address?.number}` : '';

    if (!street.trim().includes(number.trim())) {
      street = `${street}${number}${' - '}`;
    }

    var complement = address?.complement ? `${address?.complement}${' - '}` : '';

    const neighborhood = address?.neighborhood ? `${address?.neighborhood}, ` : '';
    const city = address?.city ? `${address?.city} - ` : '';
    const state = address?.state ? `${address?.state}, ` : '';
    const zipCode = address?.zipCode ? `${address?.zipCode}` : '';

    return `${street}${complement}${neighborhood}${city}${state}${zipCode}`;
  }

  function setTextDataCustomer(text?: string) {
    return text ?? '-';
  }

  return (
    <Column className="flex-lg-1 w-lg-100 pr-2 pb-md-5 mr-lg-0">
      <Text size={24} className="color-primary font-bold">
        Dados do cliente
        <Visibility visible={!!refreshCustomer}>
          <a title="atualizar dados do cliente" onClick={() => refreshCustomer && refreshCustomer()}>
            <img src={refreshBtn} alt="atualizar dados do cliente" className="ml-1" />
          </a>
        </Visibility>
      </Text>
      <Row className="mt-1 py-1 w-100 customer-content--infos">
        <Column
          className="flex-1 mr-1 pl-2"
          style={{ borderLeft: '5px solid #c4c4c480' }}
        >
          <Column className="py-lg-1">
            <Text className="font-bold color-blue-gray" size={12}>
              Razão social
            </Text>
            <Text className="color-blue-gray text-wrap" size={12}>
              {setTextDataCustomer(customer?.companyName)}
            </Text>
          </Column>
          <Column className="py-lg-1 mt-2">
            <Text className="font-bold color-blue-gray" size={12}>
              Nome fantasia
            </Text>
            <Text className="color-blue-gray text-wrap" size={12}>
              {setTextDataCustomer(customer?.fantasyName)}
            </Text>
          </Column>
          <Column className="py-lg-1 mt-2">
            <Text className="font-bold color-blue-gray" size={12}>
              CNPJ
            </Text>
            <Text className="color-blue-gray text-wrap" size={12}>
              <Document
                type="cnpj"
                value={setTextDataCustomer(customer?.documentNumber)}
              />
            </Text>
          </Column>
          <Column className="py-lg-1 mt-2">
            <Text className="font-bold color-blue-gray" size={12}>
              Endereço
            </Text>
            <Text className="color-blue-gray text-wrap" size={12}>
              {parseAddress(customer?.address)}
            </Text>
          </Column>
          <Column className="py-lg-1 mt-2">
            <Text className="font-bold color-blue-gray" size={12}>
              Telefone
            </Text>
            <Text className="color-blue-gray text-wrap" size={12}>
              {setTextDataCustomer(PhoneNumberDDDOutput(
                customer?.phone,
                customer?.areaCode
              ))}
            </Text>
          </Column>
        </Column>

        <Column
          className="flex-1 ml-md-0 ml-3 pl-2"
          style={{
            borderLeft: '5px solid #c4c4c480',
            maxWidth: 305,
          }}
        >
          <Column className="py-lg-1">
            <Text className="font-bold color-blue-gray" size={12}>
              E-mail comercial
            </Text>
            <Row className="align-start">
              <Visibility visible={!!customer?.comercialEmail}>
                <img className="mr-1" src={emailImg} alt="" width={13} height={19} />
              </Visibility>
              <Text className="color-blue-gray text-wrap" size={12}>
                {parseEmail(customer?.comercialEmail)}
              </Text>
            </Row>
          </Column>
          <Column className="py-lg-1 mt-2">
            <Text className="font-bold color-blue-gray" size={12}>
              E-mail financeiro
            </Text>
            <Row>
              <Visibility visible={!!customer?.financialEmail}>
                <img className="mr-1" src={emailImg} alt="" width={13} height={19} />
              </Visibility>
              <Text className="color-blue-gray text-wrap" size={12}>
                {parseEmail(customer?.financialEmail)}
              </Text>
            </Row>
          </Column>
          <Column className="py-lg-1 mt-2">
            <Text className="font-bold color-blue-gray" size={12}>
              Contato do cliente
            </Text>
            <Text className="color-blue-gray text-wrap" size={12}>
              {setTextDataCustomer(customer?.contactName)}
            </Text>
          </Column>
          <Column className="py-lg-1 mt-2">
            <Text className="font-bold color-blue-gray" size={12}>
              Vendedor responsável Viveo
            </Text>
            <Text className="color-blue-gray text-wrap" size={12}>
              {setTextDataCustomer(formatSeller(customer?.seller, customer?.customerBus))}
            </Text>
          </Column>
        </Column>
      </Row>

      <Visibility visible={!!refreshCustomer}>
        <Files />
      </Visibility>
    </Column>
  );
};